export const checkOutFormFields = {
	countryId: '',
	name: '',
	mobileNo: '',
	emailId: '',
	addressLine1: '',
	addressLine2: '',
	landmark: '',
	zipCode: '',
	city: '',
	stateId: '',
	districtId: '',
	saveInfo: false,
	selectedAddress: '',
}
